<app-select placeholder="channel_trad"
            appearance="outline"
            [disableSort]="true"
            [control]="control"
            controlName="channel"
            [options]="channels"
            [valueGetter]="channelValueGetter"
            [textGetter]="channelTextGetter"></app-select>
